/* Pookie's Pal - behaviour guards.
   Loaded from snippets/pp-head.liquid as a deferred, update-safe asset. */

/* ------------------------------------------------------------------
   1. Keep shoppers on the page after adding a bundle
   ------------------------------------------------------------------
   addSingleBundle() in the footer Custom Liquid finishes by doing
   `cartButton.click()` on the header cart control, which force-opens the cart
   drawer. On mobile that reads as being yanked out of browsing and towards
   checkout, which is the opposite of what we want: the item is in the basket,
   the customer should be free to carry on shopping.

   Rather than patch that 15KB inline script, we drop the synthetic click. A
   capture-phase listener on document runs before any handler bound to the
   button itself, so stopping propagation here is enough. Real taps have
   isTrusted === true and are left completely alone - only script-generated
   clicks are swallowed.

   The basket still updates: the bundle script dispatches CartLinesUpdateEvent
   and a cart:updated event, so the header count and drawer contents refresh
   in place, and the button's own "Added to basket" label is the confirmation. */

(function () {
  var CART_CONTROL = 'header [aria-label="Cart"], header a[href="/cart"], header [data-cart-drawer-toggle]';

  document.addEventListener(
    'click',
    function (event) {
      if (event.isTrusted) return;
      var target = event.target;
      if (!target || !target.closest) return;
      if (!target.closest(CART_CONTROL)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );
})();

/* ------------------------------------------------------------------
   4. Working collection filters and sorting
   ------------------------------------------------------------------
   The collection toolbar was styled by the footer bridge, but its Filter
   drawer only contained Shopify's incomplete Availability/Price facets and
   the visible Sort summary was not a reliable control.  Keep the existing
   toolbar and drawer, replacing only their contents/behaviour.  The six
   collection products are already rendered on the page, so the two small
   merchandising facets can be applied without another network request. */

(function () {
  if (window.__ppCollectionFacets) return;
  window.__ppCollectionFacets = true;

  /* The footer used to inject a second collection-filter implementation after
     first paint. That obsolete block is removed; this asset now owns the
     single filter shell and its behaviour. Keep the guard for cached markup. */
  window.__ppWoofyCollection = true;

  var COLLECTION_PATH = '/collections/all';
  var PRODUCT_DATA = {
    'freeze-dried-beef-liver-treats-dogs-cats': { protein: ['beef'], texture: 'crunchy' },
    'freeze-dried-capelin-fish-treats-cats-dogs': { protein: ['fish'], texture: 'soft' },
    'freeze-dried-chicken-treats-dogs-cats': { protein: ['chicken'], texture: 'soft' },
    'freeze-dried-chicken-hearts-dogs-cats': { protein: ['chicken'], texture: 'crunchy' },
    'freeze-dried-whole-quail-treats-dogs-cats': { protein: ['quail'], texture: 'crunchy' },
    'freeze-dried-quail-egg-yolk-dogs-cats': { protein: ['quail'], texture: 'soft' }
  };
  var installed = false;
  var cards = [];
  var mobileBridgeInstalled = false;

  function isCollection() {
    return window.location.pathname.replace(/\/$/, '') === COLLECTION_PATH;
  }

  function option(name, value, label) {
    var id = 'pp-filter-' + name + '-' + value;
    return '<label class="pp-functional-filter__option" for="' + id + '">' +
      '<input id="' + id + '" type="checkbox" data-pp-filter="' + name + '" value="' + value + '">' +
      '<span aria-hidden="true"></span><em>' + label + '</em>' +
    '</label>';
  }

  function group(legend, content) {
    return '<fieldset class="pp-functional-filter__group"><legend>' + legend + '</legend>' + content + '</fieldset>';
  }

  function filterMarkup() {
    return '<div class="pp-functional-filter">' +
      group('Availability',
        option('availability', 'in-stock', 'In stock') +
        option('availability', 'out-of-stock', 'Out of stock')) +
      group('Protein type',
        option('protein', 'beef', 'Beef') +
        option('protein', 'chicken', 'Chicken') +
        option('protein', 'fish', 'Fish') +
        option('protein', 'quail', 'Quail')) +
      group('Texture',
        option('texture', 'crunchy', 'Crunchy') +
        option('texture', 'soft', 'Soft')) +
      '<button type="button" class="pp-functional-filter__reset">Reset filters</button>' +
    '</div>';
  }

  function filterIcon() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>';
  }

  function ensureFilterShell() {
    var form = document.querySelector('.facets__form');
    if (!form) return null;

    var trigger = form.querySelector('.pp-collection-filter-button');
    if (!trigger) {
      trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'pp-collection-filter-button';
      trigger.innerHTML = filterIcon() + '<span>Filter</span>';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.setAttribute('aria-controls', 'pp-collection-filter-overlay');
      form.insertBefore(trigger, form.firstElementChild);
    }

    var overlay = document.querySelector('.pp-filter-overlay');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'pp-collection-filter-overlay';
      overlay.className = 'pp-filter-overlay';
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = '<aside class="pp-filter-drawer" role="dialog" aria-modal="true" aria-label="Filter products">' +
        '<div class="pp-filter-drawer__head"><strong>Filter treats</strong><button type="button" class="pp-filter-drawer__close" aria-label="Close filters">×</button></div>' +
        '<div class="pp-filter-drawer__body"></div>' +
        '<div class="pp-filter-drawer__foot"><button type="button" class="pp-filter-show">Show products</button></div>' +
      '</aside>';
      document.body.appendChild(overlay);
    }

    if (!trigger.hasAttribute('data-pp-filter-bound')) {
      trigger.setAttribute('data-pp-filter-bound', 'true');
      trigger.addEventListener('click', function () { openFilterOverlay(trigger); });
    }

    return overlay;
  }

  function productHandle(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    var match = link.getAttribute('href').match(/\/products\/([^?/#]+)/);
    return match ? match[1] : '';
  }

  function collectCards() {
    cards = Array.prototype.slice.call(document.querySelectorAll('#ResultsList product-card')).filter(function (card) {
      return !!PRODUCT_DATA[productHandle(card)];
    });
    cards.forEach(function (card, index) {
      var handle = productHandle(card);
      var data = PRODUCT_DATA[handle] || { protein: [], texture: '' };
      var soldOut = !!card.querySelector('button[disabled]') || /sold out/i.test(card.textContent);
      card.setAttribute('data-pp-handle', handle);
      card.setAttribute('data-pp-protein', data.protein.join(' '));
      card.setAttribute('data-pp-texture', data.texture);
      card.setAttribute('data-pp-availability', soldOut ? 'out-of-stock' : 'in-stock');
      if (!card.hasAttribute('data-pp-original-order')) {
        card.setAttribute('data-pp-original-order', String(index));
      }
      var gridItem = card.closest('.product-grid__item');
      if (gridItem) gridItem.setAttribute('data-pp-product-item', handle);
    });
  }

  function gridItemFor(card) {
    return card.closest('.product-grid__item') || card;
  }

  function unlockPage() {
    document.body.classList.remove('pp-filter-locked', 'pp-sort-locked');
    var hasOpenControl = document.querySelector(
      '.pp-filter-overlay.is-open, .pp-functional-sort.is-open, dialog.theme-drawer__dialog[open]'
    );
    if (!hasOpenControl) {
      if (document.body.style.overflow === 'hidden') document.body.style.removeProperty('overflow');
      if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.removeProperty('overflow');
    }
  }

  function selected(name) {
    return Array.prototype.slice.call(document.querySelectorAll('[data-pp-filter="' + name + '"]:checked'))
      .map(function (input) { return input.value; });
  }

  function matches(card, values, attribute, multi) {
    if (!values.length) return true;
    var cardValues = (card.getAttribute(attribute) || '').split(/\s+/);
    return values.some(function (value) {
      return multi ? cardValues.indexOf(value) !== -1 : cardValues[0] === value;
    });
  }

  function countHost() {
    var form = document.querySelector('.facets__form');
    if (!form) return null;
    return form.querySelector('.pp-woofy-count, .facets__results-count, .products-count, .facets__status');
  }

  function updateCount(count) {
    var host = countHost();
    if (!host) return;
    host.classList.add('pp-facets-live-count');
    host.textContent = count + (count === 1 ? ' product' : ' products');
    host.setAttribute('aria-live', 'polite');
  }

  function applyFilters() {
    collectCards();
    var availability = selected('availability');
    var protein = selected('protein');
    var texture = selected('texture');
    var filtering = availability.length + protein.length + texture.length > 0;
    var visible = 0;

    cards.forEach(function (card) {
      var show = matches(card, availability, 'data-pp-availability', false) &&
        matches(card, protein, 'data-pp-protein', true) &&
        matches(card, texture, 'data-pp-texture', false);
      var gridItem = gridItemFor(card);
      card.classList.toggle('pp-facet-hidden', !show);
      gridItem.classList.toggle('pp-facet-hidden', !show);
      gridItem.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) visible += 1;
    });

    var results = document.querySelector('#ResultsList');
    if (results) results.classList.toggle('pp-filtering-active', filtering);

    updateCount(visible);
    var showButton = document.querySelector('.pp-filter-show');
    if (showButton) showButton.textContent = 'Show ' + visible + (visible === 1 ? ' product' : ' products');
    var trigger = document.querySelector('.pp-collection-filter-button');
    if (trigger) {
      var totalSelected = availability.length + protein.length + texture.length;
      trigger.classList.toggle('has-active-filters', totalSelected > 0);
      trigger.setAttribute('aria-label', totalSelected ? 'Filter, ' + totalSelected + ' selected' : 'Filter');
    }
  }

  function installFilters() {
    var overlay = ensureFilterShell();
    var body = overlay && overlay.querySelector('.pp-filter-drawer__body');
    if (!body || body.querySelector('.pp-functional-filter')) return false;
    body.innerHTML = filterMarkup();
    body.addEventListener('change', function (event) {
      applyFilters();

      /* On mobile the product list is the next action after choosing a
         facet. Close the sheet immediately so its intentional scroll lock
         cannot be mistaken for a frozen page. Desktop keeps the drawer open
         so several facets can be selected together. */
      if (event.target.matches('[data-pp-filter]') && window.innerWidth <= 989) {
        closeRepairedDrawer();
      }
    });
    var reset = body.querySelector('.pp-functional-filter__reset');
    reset.addEventListener('click', function () {
      body.querySelectorAll('input[type="checkbox"]').forEach(function (input) { input.checked = false; });
      applyFilters();
    });
    var closeButton = overlay.querySelector('.pp-filter-drawer__close');
    var showButton = overlay.querySelector('.pp-filter-show');
    function closeRepairedDrawer() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      unlockPage();
      var desktopTrigger = document.querySelector('.pp-collection-filter-button');
      var mobileTrigger = document.querySelector('.facets-toggle__button');
      if (desktopTrigger) desktopTrigger.setAttribute('aria-expanded', 'false');
      if (mobileTrigger) mobileTrigger.setAttribute('aria-expanded', 'false');

      /* The legacy drawer also listens to these controls. Re-assert the
         closed state after its handler has finished so it cannot leave the
         overlay or page lock active on iOS. */
      [0, 50, 160].forEach(function (delay) {
        window.setTimeout(function () {
          overlay.classList.remove('is-open');
          overlay.setAttribute('aria-hidden', 'true');
          unlockPage();
        }, delay);
      });
    }
    [closeButton, showButton].forEach(function (control) {
      if (!control) return;
      control.addEventListener('pointerup', closeRepairedDrawer, true);
      control.addEventListener('touchend', closeRepairedDrawer, { capture: true, passive: true });
      control.addEventListener('click', closeRepairedDrawer, true);
    });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) closeRepairedDrawer();
    });
    applyFilters();
    return true;
  }

  function openFilterOverlay(trigger) {
    var overlay = document.querySelector('.pp-filter-overlay');
    if (!overlay || !overlay.querySelector('.pp-functional-filter')) return false;
    closeSort();
    unlockPage();
    document.body.classList.remove('pp-filter-selection-made');
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pp-filter-locked');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    var desktopTrigger = document.querySelector('.pp-collection-filter-button');
    if (desktopTrigger) desktopTrigger.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () {
      var close = overlay.querySelector('.pp-filter-drawer__close');
      if (close) close.focus();
    }, 50);
    return true;
  }

  function closeNativeMobileDrawer() {
    /* Horizon's theme-drawer owns the root scroll lock. Closing only its
       nested <dialog> bypasses ThemeDrawer.close(), leaving the owner's entry
       in ScrollLockManager and <html scroll-lock> stuck on iOS. Always close
       through the custom element so Horizon can release its own lock and
       restore focus/ARIA state. */
    document.querySelectorAll('theme-drawer[open], theme-drawer:has(dialog.theme-drawer__dialog[open])')
      .forEach(function (drawer) {
        if (typeof drawer.close === 'function') {
          drawer.close();
          return;
        }

        var dialog = drawer.querySelector('dialog.theme-drawer__dialog[open]');
        if (dialog) dialog.close();
      });
  }

  function installMobileBridge() {
    if (mobileBridgeInstalled) return;
    mobileBridgeInstalled = true;
    document.addEventListener('click', function (event) {
      if (!isCollection()) return;
      var target = event.target && event.target.closest && event.target.closest('.facets-toggle__button');
      if (!target) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      installFilters();
      openFilterOverlay(target);
      [0, 40, 120].forEach(function (delay) {
        window.setTimeout(closeNativeMobileDrawer, delay);
      });
    }, true);
    document.addEventListener('click', function (event) {
      if (!event.target || !event.target.closest) return;
      if (!event.target.closest('.pp-filter-drawer__close, .pp-filter-show')) return;
      var mobileTrigger = document.querySelector('.facets-toggle__button');
      if (mobileTrigger) mobileTrigger.setAttribute('aria-expanded', 'false');
    });
    document.addEventListener('change', function (event) {
      if (!isCollection() || window.innerWidth > 989 ||
          !event.target || !event.target.matches('[data-pp-filter]')) return;

      document.body.classList.add('pp-filter-selection-made');
      [0, 40, 160].forEach(function (delay) {
        window.setTimeout(function () {
          var overlay = document.querySelector('.pp-filter-overlay');
          if (overlay) {
            overlay.classList.remove('is-open');
            overlay.setAttribute('aria-hidden', 'true');
          }
          unlockPage();
          closeNativeMobileDrawer();
        }, delay);
      });
    }, true);
  }

  function sortUrl(value) {
    var url = new URL(window.location.href);
    if (value === 'manual') url.searchParams.delete('sort_by');
    else url.searchParams.set('sort_by', value);
    url.searchParams.delete('qa');
    return url.pathname + (url.search ? url.search : '');
  }

  function sortMarkup() {
    var current = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
    var options = [
      ['manual', 'Featured'],
      ['best-selling', 'Best selling'],
      ['price-ascending', 'Price, low to high'],
      ['price-descending', 'Price, high to low'],
      ['title-ascending', 'Alphabetically, A–Z'],
      ['created-descending', 'Newest arrivals']
    ];
    return '<div class="pp-functional-sort__head"><strong>Sort products</strong><button type="button" aria-label="Close sorting">×</button></div>' +
      '<div class="pp-functional-sort__options">' + options.map(function (item) {
        return '<a href="' + sortUrl(item[0]) + '"' + (item[0] === current ? ' aria-current="true"' : '') + '>' +
          '<span>' + item[1] + '</span><i aria-hidden="true"></i></a>';
      }).join('') + '</div>';
  }

  function closeSort() {
    var menu = document.querySelector('.pp-functional-sort');
    var trigger = document.querySelector('.pp-sort-trigger');
    if (menu) menu.classList.remove('is-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    unlockPage();
  }

  function positionSort(trigger, menu) {
    if (window.matchMedia('(max-width: 749px)').matches) {
      menu.style.removeProperty('top');
      menu.style.removeProperty('left');
      return;
    }
    var rect = trigger.getBoundingClientRect();
    menu.style.top = Math.round(rect.bottom + 8) + 'px';
    menu.style.left = Math.round(Math.max(12, Math.min(window.innerWidth - 292, rect.right - 280))) + 'px';
  }

  function installSort() {
    var host = document.querySelector('sorting-filter-component.sorting-filter, .sorting-filter');
    if (!host || host.querySelector('.pp-sort-trigger')) return !!host;
    host.innerHTML = '<button type="button" class="pp-sort-trigger" aria-haspopup="dialog" aria-expanded="false">' +
      '<span>Sort</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m4 6 4 4 4-4"/></svg></button>';
    var trigger = host.querySelector('.pp-sort-trigger');
    var menu = document.createElement('div');
    menu.className = 'pp-functional-sort';
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-label', 'Sort products');
    menu.innerHTML = sortMarkup();
    document.body.appendChild(menu);

    trigger.addEventListener('click', function () {
      var open = !menu.classList.contains('is-open');
      closeSort();
      if (!open) return;
      positionSort(trigger, menu);
      menu.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('pp-sort-locked');
    });
    menu.addEventListener('click', function (event) {
      if (event.target.closest('.pp-functional-sort__options a')) unlockPage();
    });
    menu.querySelector('button').addEventListener('click', closeSort);
    document.addEventListener('click', function (event) {
      if (!menu.classList.contains('is-open')) return;
      if (menu.contains(event.target) || trigger.contains(event.target) ||
        (event.target.closest && event.target.closest('.pp-mobile-sort-trigger'))) return;
      closeSort();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeSort();
    });
    window.addEventListener('resize', function () {
      if (menu.classList.contains('is-open')) positionSort(trigger, menu);
    });
    return true;
  }

  function installMobileSortTrigger() {
    var wrapper = document.querySelector('.facets-toggle__wrapper');
    var desktopTrigger = document.querySelector('.pp-sort-trigger');
    if (!wrapper || !desktopTrigger || wrapper.querySelector('.pp-mobile-sort-trigger')) return;
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'pp-mobile-sort-trigger';
    button.innerHTML = '<span>Sort</span><svg viewBox="0 0 16 16" aria-hidden="true"><path d="m4 6 4 4 4-4"/></svg>';
    button.addEventListener('click', function () { desktopTrigger.click(); });
    wrapper.appendChild(button);
  }

  function boot() {
    if (!isCollection() || installed) return;
    unlockPage();
    installMobileBridge();
    collectCards();
    ensureFilterShell();
    var attempts = 0;
    var wait = window.setInterval(function () {
      attempts += 1;
      var filtersReady = installFilters();
      var sortReady = installSort();
      if (sortReady) installMobileSortTrigger();
      if ((filtersReady && sortReady) || attempts > 30) {
        window.clearInterval(wait);
        installed = filtersReady && sortReady;
        applyFilters();
      }
    }, 100);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function () {
    installed = false;
    boot();
  });
  window.addEventListener('pageshow', function () {
    var filterOpen = document.querySelector('.pp-filter-overlay.is-open');
    var sortOpen = document.querySelector('.pp-functional-sort.is-open');
    if (!filterOpen && !sortOpen) unlockPage();
  });
  window.addEventListener('pagehide', unlockPage);
  window.addEventListener('beforeunload', unlockPage);
})();

/* ------------------------------------------------------------------
   2. No delivery-reward box on an empty basket
   ------------------------------------------------------------------
   installDeliveryProgress() injects its box at the end of the drawer. With an
   empty basket there is no cart summary for it to sit under, so it lands hard
   against the Continue Shopping button and overlaps it - and "You're 20.00
   away from FREE delivery" is noise when there is nothing in the basket.

   Emptiness is read from the theme's own server-rendered signal: cart-bubble
   carries `visually-hidden` when `cart == empty`. pp-fixes.css does the same
   thing declaratively via :has() so there is no flash before this runs; this
   pass is the fallback for browsers without :has() and the handler for the
   basket emptying without a page load. */

(function () {
  var BOXES = '.pp-drawer-delivery, [data-pp-delivery-progress]';
  var queued = false;

  function cartIsEmpty() {
    var bubble = document.querySelector('.cart-bubble');
    if (bubble) return bubble.classList.contains('visually-hidden');

    var icon = document.querySelector('.header-actions__cart-icon');
    if (icon) return !icon.classList.contains('header-actions__cart-icon--has-cart');

    return false;
  }

  function sync() {
    queued = false;
    var empty = cartIsEmpty();
    var boxes = document.querySelectorAll(BOXES);
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].style.display = empty ? 'none' : '';
    }
  }

  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(sync);
  }

  function start() {
    sync();

    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      new MutationObserver(queue).observe(drawer, { childList: true, subtree: true });
    }

    [300, 900, 1600].forEach(function (delay) {
      window.setTimeout(sync, delay);
    });
  }

  document.addEventListener('cart:updated', queue);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
